(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ea-free-field-trips"] && !Shopify.designMode) return;
  try {
    
function initEft(root) {
  if (root.dataset.eftReady) return;
  root.dataset.eftReady = 'true';
  const form = root.querySelector('.eft-form');
  if (!form) return;
  root.querySelectorAll('[data-eft-role],[data-eft-interest]').forEach(link => {
    link.addEventListener('click', () => {
      const role = form.querySelector('[name="contact[role]"]');
      const interest = form.querySelector('[name="contact[interest]"]');
      if (role && link.dataset.eftRole) role.value = link.dataset.eftRole;
      if (interest && link.dataset.eftInterest) interest.value = link.dataset.eftInterest;
    });
  });
  root.querySelectorAll('a[href^="#"]').forEach(link => {
    link.addEventListener('click', event => {
      if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      history.replaceState(history.state, '', link.getAttribute('href'));
      target.scrollIntoView({ behavior: 'instant', block: 'start' });
      target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    });
  });
}
document.querySelectorAll('.eft').forEach(initEft);
document.addEventListener('shopify:section:load', event => {
  event.target.querySelectorAll('.eft').forEach(initEft);
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
